var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { DateTime } from 'luxon';
import { blackKidIcons } from '@/support/Icon';
import { Subject } from '@/models/Subject';
import { Student } from '@/models/Student';
import { hasClass, addClass, removeClass } from '@/support/Html';
import { UserSubject, UserSubjectStatusEnum } from '@/models/UserSubject';
import { hex2rgba } from '@/support/String';
import EditSubjectStatusDialog from '@/views/Schedules/EditSubjectStatusDialog';
import UserSubjectMessageForm from '@/components/user-subject-message-form/UserSubjectMessageForm';
import EditDescriptionDialog from '@/views/Schedules/EditDescriptionDialog';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import LoadFailed from '@/views/Errors/LoadFailed';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { UserSubjectSummary } from '@/models/UserSubjectSummary';
import AlertCard from '@/components/alert-card/AlertCard';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sortByKey } from '@/support/Object';
import { excludeRoles } from '@/support/ExcludeRoles';
import ErrorHandler from '@/support/ErrorHandler';
import StatusCard from '@/components/status-card/StatusCard';
import client from '@/support/Client';
import { Template } from '@/models/Template';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import DescriptionColumn from '@/components/DescriptionColumn/DescriptionColumn.vue';
import SubjectDialog from '@/components/SubjectDialog/SubjectDialog.vue';
import ScoolSnackbar from '@/components/ScoolSnackbar/ScoolSnackbar';
import { RolesEnum } from '@/items/Roles';
import { StudentDocument } from '@/models/StudentDocument';
import { Group } from '@/models/Group';
import DownloadOverviewDialog from '@/components/DownloadOverviewDialog/DownloadOverviewDialog';
import ProgressDialog from '@/components/ProgressDialog/ProgressDialog.vue';
let SubjectOverview = class SubjectOverview extends Vue {
    constructor() {
        super(...arguments);
        this.count = 0;
        this.$pageTitle = 'Schedule Subject';
        this.selectedStatus = '';
        this.isLoading = false;
        this.isRerendering = false;
        this.selected = [];
        this.subjects = [];
        this.students = [];
        this.rooms = [];
        this.isDisplayingProgressDialog = false;
        this.hasTableContainer = '';
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        this.statuses = [];
        this.sortedSubjects = {};
        this.hasSortedSubjects = false;
        this.userIds = [];
        this.newUserSubjects = [];
        this.selectedGroups = [];
        this.groupFromQuery = '';
        this.totalSubjects = 0;
        this.selectedAll = false;
        this.selectedUsers = [];
        this.intermediateSelect = false;
        this.actionSelected = null;
        this.loadFailed = false;
        this.filters = {};
        this.allSort = {
            inactive: [],
            highlighted: [],
            busy: [],
            old: [],
            closed: [],
            finished: [],
        };
        this.templates = [];
        this.subjectTarget = null;
        this.isShowingEditSubjectDialog = false;
        this.subjectDialogStudent = null;
        this.subjectDialogSubject = null;
        this.isSubjectDialogOpen = false;
        this.isShowingSnackbar = true;
        this.statusColorMap = {
            highlighted: '#f8c623',
            busy: '#008ac4',
            old: '#ff7800',
            inactive: '#9b9b9b',
            closed: '#d0021b',
            finished: '#00b900',
        };
        this.isDisplayingStudentNotes = false;
        this.selectedStudent = null;
        this.isShowingStatusDialog = false;
        this.isDisplayingIdpNotesDialog = false;
        this.isDisplayingSubjectDialog = false;
        this.isDownloadingOverview = false;
        this.isDisplayingDownloadDialog = false;
        this.downloadOverviewUrl = '';
        // Subject description dialog end
    }
    get hasSelectedStatus() {
        return !!Object.keys(this.sortedSubjects).length;
    }
    get studentIds() {
        const ids = [];
        this.students.forEach((student) => {
            ids.push(student.id || '');
        });
        return ids;
    }
    get subjectIds() {
        const ids = [];
        this.subjects.forEach((subject) => {
            ids.push(subject.id || '');
        });
        return ids;
    }
    get selectedCount() {
        let count = 0;
        this.selectedUsers.forEach((item) => {
            if (item !== null) {
                count += 1;
            }
        });
        return count;
    }
    get userSubjectRooms() {
        const rooms = [];
        const usersubjects = [];
        this.userSubjectIds.forEach((subjectId) => {
            this.statuses.forEach((status) => {
                if (subjectId === status.id && status.status === 'highlighted' && status.room) {
                    rooms.push(status.room);
                }
            });
        });
        return rooms;
    }
    get userSubjectIds() {
        const ids = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            this.statuses.forEach((status) => {
                if (subjectId === status.subject && this.sortedSubjects[subjectId].includes(status.user.toString())) {
                    ids.push(status.id);
                }
            });
        });
        return ids;
    }
    get selectedSubjectIds() {
        const subjectIds = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            subjectIds.push(subjectId);
        });
        return Array.from(new Set(subjectIds));
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get selectedUserSubjects() {
        const selectedSubjects = [];
        Object.keys(this.sortedSubjects).forEach((key) => this.sortedSubjects[key].forEach((userId) => {
            const student = this.findStudentById(userId);
            if (student && student.subjects && student.subjects[key]) {
                selectedSubjects.push(student.subjects[key]);
            }
        }));
        return selectedSubjects;
    }
    get snackbarActions() {
        const areSelectedSubjectsBusy = this.selectedUserSubjects.every((subject) => subject.status === UserSubjectStatusEnum.HIGHLIGHTED);
        return [
            {
                icon: 'do_not_disturb_on',
                click: () => {
                    this.emptySelected();
                },
                label: this.$t('snackbar.actions.deselect').toString(),
            },
            ...(areSelectedSubjectsBusy
                ? [
                    {
                        icon: 'edit',
                        click: () => {
                            this.isDisplayingProgressDialog = true;
                        },
                        label: 'Voortgang',
                    },
                ]
                : []),
            {
                icon: 'list',
                click: () => {
                    this.isDisplayingSubjectDialog = true;
                },
                label: this.$t('snackbar.actions.roadmap').toString(),
            },
            {
                icon: 'nearby_error',
                click: () => {
                    this.onPriorityChange(true);
                },
                label: 'Prio geven',
            },
            {
                icon: 'not_interested',
                click: () => {
                    this.onPriorityChange(false);
                },
                label: 'Prio verwijderen',
            },
            ...(this.exclude
                ? []
                : [
                    {
                        icon: 'question_answer',
                        click: () => {
                            this.openIdpNotesDialog();
                        },
                        label: this.$t('snackbar.actions.chat').toString(),
                    },
                    {
                        icon: 'error_outline',
                        click: () => {
                            this.$store.dispatch('openDialog', this.dialogOptionsResetStudentStatuses);
                        },
                        label: this.$t('snackbar.actions.reset_statuses').toString(),
                    },
                ]),
        ];
    }
    get snackbarCount() {
        let count = 0;
        Object.entries(this.sortedSubjects).forEach(([key, value]) => {
            count += value.length;
        });
        return count;
    }
    get breadcrumbs() {
        return [
            { name: this.$t('summary.title').toString(), path: '/subjects' },
            // { name: this.schedule.name || '', path: this.$route.path }
        ];
    }
    get dialogOptionsResetStudentStatuses() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.reset', { item: this.$t('dialogOptions.item.helpAndFinished') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.reset').toString(),
                    action: () => {
                        const subjects = [];
                        const users = [];
                        Object.keys(this.sortedSubjects).forEach((id) => {
                            subjects.push(id);
                        });
                        Object.keys(this.sortedSubjects).forEach((id) => {
                            if (id) {
                                this.sortedSubjects[id].forEach((user) => {
                                    users.push(user);
                                });
                            }
                        });
                        const payload = {
                            users,
                            subjects,
                        };
                        new UserSubject()
                            .bulkUpdateClearStudentStatuses(payload)
                            .then((response) => {
                            this.handleStatusChanged();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    async onProgressChanged(progress) {
        const promiseArray = [];
        const test = Object.keys(this.sortedSubjects).forEach((subjectId) => this.sortedSubjects[subjectId].forEach((userId) => {
            const user = new UserSubject().user(userId).put([{ subject: subjectId, progress }]);
            promiseArray.push(user);
        }));
        Promise.all(promiseArray).then(this.handleStatusChanged);
    }
    mounted() {
        if (this.$route.query.group) {
            this.selectedGroups.push(`${this.$route.query.group}`);
        }
        window.addEventListener('scroll', this.windowScroll);
        this.initialize();
    }
    initialize() {
        this.isLoading = false;
        if (this.overrideFilterRequirement && this.subjectSummary) {
            this.handleUserSubjectSummary(this.subjectSummary);
        }
        else {
            this.fetchUserSubjects();
        }
        this.$nextTick(() => this.setNameColumnRowHeight());
        // TEMP REMOVE @TODO DEBUG
        // this.selectedLevels = ['8b9653b3-0949-4257-a46a-8b88aabbe065'];
    }
    async fetchUserSubjects() {
        const checkLevels = this.needsToCheckLevels ? this.selectedLevels.length > 0 : true;
        if (this.count > 0) {
            // if (this.selectedLevels.length > 0 || this.selectedGroups.length > 0 || this.event) {
            if (checkLevels || this.selectedGroups.length > 0 || this.event) {
                this.isLoading = true;
                this.loadFailed = false;
                new UserSubjectSummary()
                    .include(['parent', 'level', 'period'])
                    .filter(this.summaryFilters)
                    .load()
                    .then((response) => {
                    this.handleUserSubjectSummary(response);
                })
                    .catch((error) => {
                    this.isLoading = false;
                    this.loadFailed = true;
                });
            }
            else {
                this.isLoading = false;
            }
        }
        this.count++;
    }
    get needsToCheckLevels() {
        return !!!this.initialGroup;
    }
    get summaryFilters() {
        const filter = {
            statuses: this.selectedStatuses && this.selectedStatuses.length ? this.selectedStatuses : [UserSubjectStatusEnum.BUSY, UserSubjectStatusEnum.HIGHLIGHTED, UserSubjectStatusEnum.OLD, UserSubjectStatusEnum.FINISHED, UserSubjectStatusEnum.CLOSED],
        };
        if (this.topic) {
            filter.topic = this.topic.id;
        }
        if (this.event) {
            filter.event = this.event.id;
        }
        if (this.selectedPeriods) {
            filter.periods = this.selectedPeriods;
        }
        if (this.selectedLevels) {
            filter.levels = this.selectedLevels;
        }
        if (this.selectedGroups) {
            filter.groups = this.selectedGroups;
        }
        if (this.selectedProject) {
            filter.project = this.selectedProject;
        }
        return filter;
    }
    handleUserSubjectSummary(response) {
        if (response.data.data) {
            this.statuses = this.$set(this, 'statuses', new UserSubject().dataToModel({}, 'UserSubject', response.data.data));
            this.statuses.forEach((status) => {
                this.rooms.push(status.room);
            });
        }
        if (response.data.meta.subjects) {
            this.$set(this, 'subjects', new Subject().dataToModel({}, 'Subject', response.data.meta.subjects.sort(sortByKey('name'))));
        }
        if (response.data.meta.users) {
            this.$set(this, 'students', new Student().include(['treatment_labels']).dataToModel({}, 'Student', response.data.meta.users.sort(sortByKey('name'))));
        }
        this.morphUserSubjects();
    }
    /**
     * Morphs the data for predetermined row styles, labels, etc.
     */
    morphUserSubjects() {
        const students = this.students;
        students.forEach((student, studentIndex) => {
            student.url = student.url();
            this.students[studentIndex].subjects = {};
            this.subjects.forEach((subject) => {
                const status = this.getStudentStatus(subject, student, false);
                this.students[studentIndex].subjects[subject.id] = {
                    statusPillCellStyles: this.getStatusPillCellStyles(subject, student),
                    statusPillCellHighlightedStyles: this.getStatusPillCellStyles(subject, student, true),
                    statusPillStyles: this.getStatusPillStyles(subject, student),
                    statusTranslated: this.getStudentStatus(subject, student, true),
                    status,
                    isLinkedToProject: this.getStudentProject(subject, student),
                    isFinished: status === 'finished',
                    rating: this.getSubjectRating(subject, student),
                    markedAsFinished: this.getStudentMarkedAsFinishedStatus(subject, student),
                    description: this.getStudentDescription(subject, student),
                    has_requested_help: this.getStudentHasRequestedHelp(subject, student),
                    has_priority: this.getStudentHasPriority(subject, student),
                    progress: this.getSubjectProgress(subject, student),
                };
            });
        });
        this.students = students;
        this.isLoading = false;
    }
    getSubjectProgress(subject, user) {
        let progress = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                progress = userSubject.progress;
            }
        });
        return progress;
    }
    getSubjectStatusCount(subject) {
        const totals = {
            highlighted: 0,
            busy: 0,
            old: 0,
            inactive: this.students.length,
            closed: 0,
            finished: 0,
            future: 0,
        };
        this.statuses.forEach((userSubject, index) => {
            if (userSubject.subject !== subject.id) {
                return;
            }
            if (totals[userSubject.status || ''] !== undefined) {
                totals.inactive -= 1;
                totals[userSubject.status] += 1;
            }
        });
        return totals;
    }
    date(key) {
        return DateTime.local();
        // return DateTime.fromSQL((this.schedule as any)[key]);
    }
    icon(key) {
        key = key || 'others';
        return blackKidIcons[key];
    }
    getStudentStatus(subject, user, translate = false) {
        let status = 'inactive';
        if (this.statuses.length === 0) {
            return status;
        }
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                status = userSubject.status || '';
            }
        });
        if (translate && status.length > 0) {
            return this.subjectStatusLabel(status);
        }
        return status;
    }
    getSubjectRating(subject, user) {
        let rating = 0;
        if (this.statuses.length === 0) {
            return rating;
        }
        this.statuses.forEach((userSubjectSummary) => {
            if (!userSubjectSummary.user || !userSubjectSummary.subject) {
                return;
            }
            if (userSubjectSummary.user.toString() === user.id && userSubjectSummary.subject === subject.id) {
                rating = userSubjectSummary.rating || 0;
            }
        });
        return rating;
    }
    changedSelectedAll(status) {
        this.selectedUsers.forEach((item, index) => {
            this.$set(this.selectedUsers, index, status ? this.students[index].id : null);
        });
    }
    selectedUsersChanged(selection) {
        const count = this.selectedCount;
        if (count === 0) {
            this.selectedAll = false;
        }
        this.intermediateSelect = count !== selection.length && count > 0;
    }
    setAllSort(subject, status) {
        if (!subject.id) {
            return;
        }
        const index = this.allSort[status].findIndex((subjectId) => {
            return subjectId === subject.id;
        });
        if (index >= 0) {
            this.allSort[status].splice(index, 1);
        }
        else {
            this.allSort[status].push(subject.id);
        }
    }
    isAllSorted(subject, status) {
        if (!subject.id) {
            return false;
        }
        return this.allSort[status].includes(subject.id);
    }
    clearSortedSubjects(subject, status) {
        if (!subject.id) {
            return;
        }
        if (this.sortedSubjects[subject.id]) {
            const subjectId = subject.id;
            const users = this.sortedSubjects[subject.id];
            const userSubjects = status !== 'inactive' ? this.pluckStudentBySubjectStatus(subject, status) : this.pluckStudentsWithInactiveSubject(subject, status);
            const clearedSortedSubjects = this.sortedSubjects[subject.id].filter((id) => {
                return !userSubjects.includes(id);
            });
            this.$set(this.sortedSubjects, subject.id, clearedSortedSubjects);
            if (!clearedSortedSubjects.length) {
                users.forEach((studentId) => {
                    this.setCellNeutral(subjectId, studentId);
                });
                delete this.sortedSubjects[subject.id];
            }
            else {
                userSubjects.forEach((studentId) => {
                    this.setCellNeutral(subjectId, studentId);
                });
            }
            this.allSort[status] = this.allSort[status].filter((id) => {
                return id !== subject.id;
            });
            this.handleActionList();
        }
    }
    pluckStudentBySubjectStatus(subject, status) {
        return this.statuses
            .filter((userSubject) => {
            return userSubject.subject === subject.id && userSubject.status === status;
        })
            .map((user) => {
            return user.user;
        });
    }
    pluckStudentsWithInactiveSubject(subject, status) {
        const studentsWithSubject = this.statuses.filter((userSubject) => {
            return userSubject.subject === subject.id;
        });
        return this.students
            .filter((student) => {
            if (studentsWithSubject.findIndex((studentWithSubject) => {
                return studentWithSubject.user === student.id;
            }) < 0) {
                return true;
            }
            return false;
        })
            .map((user) => {
            return user.id;
        });
    }
    sortSummary(subject, status) {
        if (!subject.id) {
            return;
        }
        // Alles alles statusses van hetzelfde doel zijn geslecteerd -> clear
        if (this.isAllSorted(subject, status)) {
            this.clearSortedSubjects(subject, status);
            return;
        }
        let subjectStatusses = this.sortedSubjects[subject.id] || [];
        let students = [];
        if (status !== 'inactive') {
            students = this.pluckStudentBySubjectStatus(subject, status);
        }
        else {
            students = this.pluckStudentsWithInactiveSubject(subject, status);
            students.forEach((studentId) => {
                const index = this.newUserSubjects.findIndex((newUserSubject) => {
                    return newUserSubject.subject === subject.id && newUserSubject.user === studentId;
                });
                if (index < 0) {
                    this.newUserSubjects.push({ subject: subject.id, user: studentId });
                }
            });
        }
        this.setAllSort(subject, status);
        subjectStatusses = [...new Set([...subjectStatusses, ...students])];
        const subjectId = subject.id;
        students.forEach((studentId) => {
            this.setCellHighlighted(subjectId, studentId);
        });
        this.$set(this.sortedSubjects, subject.id, subjectStatusses);
        this.handleActionList();
        this.userIds = this.sortedSubjects[subject.id] || [];
    }
    userStatusClasses(subject, student) {
        const sorted = this.sortedSubjects;
        const status = this.getStudentStatus(subject, student);
        const classes = [`statusPillCell--${status}`];
        if (subject.id && sorted[subject.id] && sorted[subject.id].includes(status)) {
            classes.push('active');
        }
        return classes;
    }
    selectItem(value) { }
    select(event) {
        // subject, student,
        let target = event.target;
        if (event.target && (!target.hasAttribute('data-subject') || !target.hasAttribute('data-student'))) {
            target = target.parentElement;
            if (event.target && (!target.hasAttribute('data-subject') || !target.hasAttribute('data-student'))) {
                event.preventDefault();
                return;
            }
        }
        const subject = this.findSubjectById(target.getAttribute('data-subject'));
        const student = this.findStudentById(target.getAttribute('data-student'));
        if (!subject || !subject.id || !student || !student.id) {
            return;
        }
        if (this.getStudentStatus(subject, student) === 'inactive') {
            this.setNewUserSubject(subject, student);
        }
        const subjectStatusses = this.sortedSubjects[subject.id] || [];
        if (subjectStatusses.includes(student.id)) {
            const index = subjectStatusses.findIndex((item) => {
                return item === student.id;
            });
            target.style.backgroundColor = student.subjects[subject.id].statusPillCellStyles.backgroundColor;
            subjectStatusses.splice(index, 1);
        }
        else {
            target.style.backgroundColor = student.subjects[subject.id].statusPillCellHighlightedStyles.backgroundColor;
            subjectStatusses.push(student.id);
        }
        if (!subjectStatusses.length) {
            this.clearSortedSubjects(subject, this.getStudentStatus(subject, student));
        }
        if (subjectStatusses.length) {
            this.$set(this.sortedSubjects, subject.id, subjectStatusses);
        }
        else {
            delete this.sortedSubjects[subject.id];
        }
        this.handleActionList();
        this.userIds = this.sortedSubjects[subject.id] || [];
    }
    setNewUserSubject(subject, student) {
        if (!subject.id || !student.id) {
            return;
        }
        const index = this.newUserSubjects.findIndex((newUserSubject) => {
            return newUserSubject.subject === subject.id && newUserSubject.user === student.id;
        });
        if (index < 0) {
            this.newUserSubjects.push({ subject: subject.id, user: student.id });
        }
        else {
            this.newUserSubjects.splice(index, 1);
        }
    }
    getStatusPillCellStyles(subject, student, highlighted = false) {
        const sorted = this.sortedSubjects;
        const status = this.getStudentStatus(subject, student);
        const color = this.statusColorMap[status] || '#000';
        if (highlighted || (subject.id && sorted[subject.id] && sorted[subject.id].includes(student.id))) {
            const lightColor = status === 'highlighted' ? hex2rgba(color, 0.4) : hex2rgba(color, 0.2);
            return { backgroundColor: `${lightColor}` };
        }
        return { backgroundColor: `#FFFFFF` };
    }
    getStatusPillStyles(subject, student) {
        const status = this.getStudentStatus(subject, student, false);
        const color = this.statusColorMap[status] || '#000';
        return { backgroundColor: `${color}` };
    }
    handleStatusChanged() {
        this.emptySelected();
        this.fetchUserSubjects();
        this.$emit('subjectsUpdated');
    }
    emptySelected() {
        this.selectedAll = false;
        this.selected = [];
        this.sortedSubjects = {};
        this.newUserSubjects = [];
        this.selectedUsers = [];
        this.totalSubjects = 0;
        this.hasSortedSubjects = false;
        this.clearAllSort();
        this.clearPillCellStyles();
        this.rerender();
    }
    parseSortedSubjects() {
        const sortedStudents = {};
        Object.keys(this.sortedSubjects).forEach((id) => {
            const students = this.sortedSubjects[id];
            students.forEach((student) => {
                if (!sortedStudents[student]) {
                    sortedStudents[student] = [id];
                }
                else {
                    sortedStudents[student].push(id);
                }
            });
        });
        return sortedStudents;
    }
    showStatusDialog() {
        this.isShowingStatusDialog = true;
    }
    openIdpNotesDialog() {
        this.isDisplayingIdpNotesDialog = true;
    }
    isSelectedUser(userId) {
        return this.selectedUsers.includes(userId);
    }
    isSelectedSubject(subjectId) {
        return Object.keys(this.sortedSubjects).includes(subjectId);
    }
    findSubjectById(id) {
        return this.subjects.find((subject) => {
            return subject.id === id;
        });
    }
    findStudentById(id) {
        return this.students.find((student) => {
            return student.id === id;
        });
    }
    rerender() {
        this.isRerendering = true;
        this.$nextTick(() => {
            this.isRerendering = false;
        });
    }
    getQuerySelector(subjectId, studentId) {
        let query = `[data-subject="${subjectId}"]`;
        if (studentId) {
            query = `${query}[data-student="${studentId}"]`;
        }
        return query;
    }
    findCellById(subjectId, studentId) {
        const query = this.getQuerySelector(subjectId, studentId);
        return document.querySelector(query);
    }
    setCellState(subjectId, studentId, isHighlighted) {
        const pillCell = this.findCellById(subjectId, studentId);
        if (!pillCell) {
            return;
        }
        let cellStyle = { backgroundColor: '#FFF' };
        if (studentId) {
            const student = this.findStudentById(studentId);
            cellStyle = isHighlighted ? student.subjects[subjectId].statusPillCellHighlightedStyles : student.subjects[subjectId].statusPillCellStyles;
        }
        pillCell.style.backgroundColor = cellStyle.backgroundColor;
    }
    setCellNeutral(subjectId, studentId) {
        this.setCellState(subjectId, studentId, false);
    }
    setCellHighlighted(subjectId, studentId) {
        this.setCellState(subjectId, studentId, true);
    }
    addMenuListener() {
        document.addEventListener('click', (event) => {
            this.hideUserMenu(event);
        });
        this.tableScroll;
    }
    hideUserMenu(event) {
        if (event !== undefined) {
            const target = event.target;
            if (hasClass(target, 'userMenubutton') || hasClass(target, 'userMenu') || hasClass(target, 'userMenu__item')) {
                return;
            }
        }
        if (document.querySelectorAll('.userMenu.show')[0]) {
            const activeMenu = document.querySelectorAll('.userMenu.show')[0];
            removeClass(activeMenu, 'show');
        }
    }
    showUserMenu(event) {
        const target = event.target;
        const activeButton = document.querySelectorAll('.userMenu.show')[0];
        if (activeButton) {
            removeClass(activeButton, 'show');
        }
        const menu = target.querySelectorAll('.userMenu')[0];
        addClass(menu, 'show');
    }
    tableScroll(event) {
        const target = event.currentTarget;
        const fixedTable = document.getElementsByClassName('goalsummaryTable--fixed')[0];
        const scrollPosLeft = target.scrollLeft;
        if (scrollPosLeft > 1) {
            addClass(fixedTable, 'show');
            fixedTable.style.left = scrollPosLeft + 'px';
            if (document.querySelectorAll('.userMenu--full.show')[0]) {
                const activeMenu = document.querySelectorAll('.userMenu--full.show')[0];
                removeClass(activeMenu, 'show');
            }
        }
        else {
            removeClass(fixedTable, 'show');
            if (document.querySelectorAll('.userMenu--fixed.show')[0]) {
                const activeMenu = document.querySelectorAll('.userMenu--fixed.show')[0];
                removeClass(activeMenu, 'show');
            }
        }
    }
    windowScroll(event) {
        const table = document.getElementsByClassName('goalsummaryTableContainer')[0];
        const fixedHeader = document.getElementsByClassName('goalsummaryTable--fixedheading')[0];
        const headerOffset = table.getBoundingClientRect().top;
        if (headerOffset < -20) {
            addClass(fixedHeader, 'show');
            fixedHeader.style.top = headerOffset * -1 + 'px';
        }
        else {
            removeClass(fixedHeader, 'show');
        }
    }
    onClickSideScrollSummaryTable(direction) {
        const scrollableContainer = document.querySelector('.goalsummaryTableContainer');
        if (!scrollableContainer) {
            return;
        }
        this.sideScrollSummaryTable(scrollableContainer, direction);
    }
    sideScrollSummaryTable(element, direction) {
        // 262.5 is the width of a table column.
        const amountToScroll = 262.5 * 1;
        element.scrollBy({
            left: direction === 'left' ? -Math.abs(amountToScroll) : amountToScroll,
            behavior: 'smooth',
        });
    }
    // Subject Dialog Start
    async showSubjectDialog(subjectId, student, ignoreStatusCheck = false) {
        if (!subjectId || !student) {
            return;
        }
        this.subjectDialogStudent = student;
        await this.fetchUserSubject(subjectId, student.id ? student.id : '');
        if (['dismissed', 'future'].includes((this.subjectTarget && this.subjectTarget.status) || '') && !ignoreStatusCheck) {
            return;
        }
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(subjectId);
        }
        this.isShowingEditSubjectDialog = true;
    }
    async fetchUserSubject(subjectId, studentId) {
        try {
            this.subjectTarget = await new UserSubject()
                .user(studentId || '')
                .include(['finished_user', 'available_at_period', 'added_by_user'])
                .filter({ subjects: [subjectId] })
                .first();
        }
        catch (error) {
            //
        }
    }
    async getTemplates(subjectId) {
        try {
            this.templates = await new Template().subject(subjectId).include('file').all();
        }
        catch (error) {
            //
        }
    }
    canShowSubjectDialog(status) {
        if (status === 'inactive' || status === 'future') {
            return false;
        }
        return true;
    }
    async onClickNavigateToGroupDocument(id) {
        const groupId = id || this.selectedGroups[0];
        if (!groupId) {
            return;
        }
        try {
            const documents = await new StudentDocument()
                .include('file')
                .filter({
                group: groupId,
                is_primary: true,
            })
                .all();
            if (!documents || !documents[0].file) {
                return;
            }
            window.open(`/groups/${groupId}/plan?document=${documents[0].id}`, '_blank');
        }
        catch (error) {
            //
        }
    }
    openTreatmentDialog(studentId) {
        this.selectedStudentId = studentId;
        this.isEditingTreatment = true;
    }
    onClickDownloadOverview() {
        this.downloadOverview();
    }
    parseToFilter(filters, value) {
        if (typeof filters === 'string') {
            const key = filters;
            filters = {};
            filters[key] = value ? value : null;
        }
        return { ...this.summaryFilters, ...filters };
    }
    async downloadOverview() {
        this.isDownloadingOverview = true;
        try {
            let filters = {};
            switch (this.$route.name) {
                case 'subject.lvs': // parent: src/views/Groups/Tabs/Subject.vue
                    filters = {
                        ...filters,
                        statuses: [UserSubjectStatusEnum.BUSY, UserSubjectStatusEnum.HIGHLIGHTED, UserSubjectStatusEnum.OLD, UserSubjectStatusEnum.CLOSED],
                        group: this.$route.params.id,
                        area: this.$route.params.subjectid,
                        project: this.initialGroup && this.initialGroup.projects && this.initialGroup.projects.length > 0 ? this.initialGroup.projects.map(project => project.id) : undefined,
                        levels: typeof this.$route.query.levels === 'string' ? [this.$route.query.levels] : this.$route.query.levels,
                        periods: typeof this.$route.query.periods === 'string' ? [this.$route.query.periods] : this.$route.query.periods,
                    };
                    filters = this.parseToFilter(filters);
                    delete filters.topic;
                    break;
                case 'subjects.summary': // parent: src/views/Subjects/Summary.vue
                case 'user-roster': // parent: StudentOverviewTableDialog -> EditEventDialog -> Roster -> src/views/Users/UserRoster.vue
                default:
                    filters = {
                        ...filters,
                        ...this.filters,
                    };
                    filters = this.parseToFilter(filters);
                    break;
            }
            const download = await client('get', 'subjects/export-summary', { filters, ...{ with: ['parent'] } });
            this.isDisplayingDownloadDialog = true;
            this.downloadOverviewUrl = download.data.pdf;
            // window.open(download.data.pdf, '_blank');
        }
        catch (error) {
            if (error.response) {
                ErrorHandler.network(error);
            }
        }
        finally {
            this.isDownloadingOverview = false;
        }
    }
    async onStatusChanged(status, isDefault) {
        this.selectedStatus = status;
        if (isDefault) {
            this.isShowingStatusDialog = true;
            return;
        }
        await this.update();
        this.handleStatusChanged();
        this.selectedStatus = '';
    }
    async update() {
        const subjects = [];
        Object.keys(this.sortedSubjects).forEach((subjectId) => {
            const subjectUsers = this.sortedSubjects[subjectId];
            subjectUsers.forEach((userId) => {
                subjects.push({
                    subject: subjectId,
                    user: userId,
                });
            });
        });
        const payload = {
            subjects,
            status: this.selectedStatus,
        };
        await new UserSubject().bulkUpdate(payload).catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getStudentMarkedAsFinishedStatus(subject, user) {
        let status = false;
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                status = userSubject.is_marked_as_finished_by_student;
            }
        });
        return status;
    }
    getStudentHasRequestedHelp(subject, user) {
        let has_requested_help = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                has_requested_help = userSubject.has_requested_help;
            }
        });
        return has_requested_help === '1' || has_requested_help ? true : false;
    }
    getStudentHasPriority(subject, user) {
        let has_priority;
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                has_priority = userSubject.has_priority;
            }
        });
        return has_priority === undefined ? false : has_priority;
    }
    getStudentProject(subject, user) {
        let isLinkedToProject = false;
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                isLinkedToProject = userSubject.is_linked_to_project;
            }
        });
        return isLinkedToProject;
    }
    async onPriorityChange(state) {
        const payloads = [];
        Object.entries(this.sortedSubjects).forEach(([key, values]) => {
            values.map((userId) => {
                payloads.push({
                    userId,
                    subjectId: key,
                    has_priority: state,
                });
            });
        });
        const promises = payloads.map(async (payload) => {
            return await this.updatePriority(payload.userId, payload.subjectId, payload.has_priority);
        });
        await Promise.all(promises);
        this.handleStatusChanged();
    }
    async updatePriority(userId, subjectId, priority) {
        return await new UserSubject().user(userId).putSubject([
            {
                subject: subjectId,
                has_priority: priority,
            },
        ]);
    }
    getStudentDescription(subject, user) {
        let description = '';
        this.statuses.forEach((userSubject) => {
            if (userSubject.user.toString() === user.id && userSubject.subject === subject.id) {
                description = userSubject.description;
            }
        });
        return description;
    }
    setNameColumnRowHeight() {
        const summaryTable = document.querySelector('.goalsummaryTableContainer');
        if (!summaryTable) {
            return;
        }
        summaryTable.addEventListener('scroll', (event) => {
            const nameColumnTarget = document.querySelector('.goalsummaryTableContainer .show thead tr');
            if (!nameColumnTarget) {
                return;
            }
            const mainTableHeadRow = document.querySelector('.goalsummaryTableContainer .goalsummaryTable:nth-child(4) thead tr');
            const height = (mainTableHeadRow ? mainTableHeadRow.clientHeight : 105).toString();
            nameColumnTarget.style.height = `${height}px`;
        });
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    handleActionList() {
        if (Object.keys(this.sortedSubjects).length) {
            this.hasSortedSubjects = true;
        }
        else {
            this.hasSortedSubjects = false;
        }
    }
    idpNotesDialogStateChanged(visible) {
        if (visible === false) {
            this.actionSelected = null;
        }
    }
    selectedPeriodsChanged(periods) {
        this.emptySelected();
        this.$debounce('fetchUserSubjects');
    }
    selectedLevelsChanged(levels) {
        this.emptySelected();
        this.$debounce('fetchUserSubjects');
    }
    onSelectedStatusesChange(newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        this.emptySelected();
        this.$debounce('fetchUserSubjects');
    }
    selectedGroupsChanged(groups) {
        this.emptySelected();
        this.$debounce('fetchUserSubjects');
        this.$emit('groupsChanged', groups);
    }
    isShowingStatusDialogChange(isVisible) {
        if (isVisible) {
            this.totalSubjects = this.newUserSubjects.length + this.userSubjectIds.length;
        }
    }
    ifFetched() {
        this.hasTableContainer = document.getElementsByClassName('goalsummaryTableContainer')[0];
    }
    hasScrollAbleTable() {
        const fixedSide = document.getElementsByClassName('goalsummaryTable--fixedside')[0];
        const sideOffset = this.hasTableContainer.getBoundingClientRect().left;
    }
    destroyed() {
        window.removeEventListener('scroll', this.windowScroll);
    }
    clearAllSort() {
        this.$set(this.allSort, 'busy', []);
        this.$set(this.allSort, 'highlighted', []);
        this.$set(this.allSort, 'closed', []);
        this.$set(this.allSort, 'finished', []);
        this.$set(this.allSort, 'inactive', []);
        this.$set(this.allSort, 'old', []);
    }
    clearPillCellStyles() {
        document.querySelectorAll('.statusPillCell').forEach((element) => {
            element.setAttribute('style', '');
        });
    }
    onProgressUpdated(progress) {
        if (!this.subjectTarget || !this.subjectTarget.subject || !this.subjectDialogStudent) {
            return;
        }
        const subjectCell = document.querySelector(`[data-subject="${this.subjectTarget.subject}"][data-student="${this.subjectDialogStudent.id}"] `);
        if (!subjectCell) {
            return;
        }
        const steps = subjectCell.querySelector('.steps');
        if (!steps) {
            return;
        }
        let progressClass = null;
        steps.classList.forEach((className) => {
            if (className.includes('progress')) {
                progressClass = className;
            }
        });
        if (progressClass) {
            steps.classList.replace(progressClass, `progress-${progress}`);
        }
    }
    // Subject Dialog End
    // Subject description dialog start
    onOpenSubjectDialog(subject) {
        if (!subject || !subject.id) {
            return;
        }
        this.subjectDialogSubject = subject;
        this.isSubjectDialogOpen = true;
    }
    get subjectIdForTreatementDialog() {
        if (this.$route.params.subjectid) {
            return this.$route.params.subjectid;
        }
        return this.$route.params.id;
    }
    onDefaultSelectedGroupsChanged(newGroups) {
        this.selectedGroups = newGroups;
    }
};
__decorate([
    Prop({ default: () => null }),
    __metadata("design:type", Object)
], SubjectOverview.prototype, "event", void 0);
__decorate([
    Prop({ default: () => null }),
    __metadata("design:type", Object)
], SubjectOverview.prototype, "topic", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], SubjectOverview.prototype, "selectedLevels", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], SubjectOverview.prototype, "selectedPeriods", void 0);
__decorate([
    Prop({ default: () => '' }),
    __metadata("design:type", String)
], SubjectOverview.prototype, "selectedProject", void 0);
__decorate([
    Prop({ required: false, default: () => [] }),
    __metadata("design:type", Array)
], SubjectOverview.prototype, "selectedStatuses", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], SubjectOverview.prototype, "defaultSelectedGroups", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectOverview.prototype, "overrideFilterRequirement", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Object)
], SubjectOverview.prototype, "subjectSummary", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Group !== "undefined" && Group) === "function" ? _c : Object)
], SubjectOverview.prototype, "initialGroup", void 0);
__decorate([
    Watch('selectedAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "changedSelectedAll", null);
__decorate([
    Watch('selectedUsers'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "selectedUsersChanged", null);
__decorate([
    Watch('isDisplayingIdpNotesDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "idpNotesDialogStateChanged", null);
__decorate([
    Watch('selectedPeriods'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_d = typeof Object !== "undefined" && Object) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "selectedPeriodsChanged", null);
__decorate([
    Watch('selectedLevels'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_e = typeof Object !== "undefined" && Object) === "function" ? _e : Object]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "selectedLevelsChanged", null);
__decorate([
    Watch('selectedStatuses', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "onSelectedStatusesChange", null);
__decorate([
    Watch('selectedGroups'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_f = typeof Object !== "undefined" && Object) === "function" ? _f : Object]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "selectedGroupsChanged", null);
__decorate([
    Watch('isShowingStatusDialog'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "isShowingStatusDialogChange", null);
__decorate([
    Watch('fetchUserSubjects'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "ifFetched", null);
__decorate([
    Watch('hasTableContainer'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "hasScrollAbleTable", null);
__decorate([
    Watch('defaultSelectedGroups', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SubjectOverview.prototype, "onDefaultSelectedGroupsChanged", null);
SubjectOverview = __decorate([
    Component({
        components: {
            ProgressDialog,
            AlertCard,
            PageHeader,
            EditSubjectStatusDialog,
            UserSubjectMessageForm,
            EditDescriptionDialog,
            LoadFailed,
            LoaderCard,
            SelectFilter,
            TreatmentDialog,
            StatusCard,
            EditSubjectDialog,
            DescriptionColumn,
            SubjectDialog,
            ScoolSnackbar,
            DownloadOverviewDialog,
        },
    })
], SubjectOverview);
export default SubjectOverview;
